// extracted by mini-css-extract-plugin
export default {"container":"Yn-z","bubbleNav":"Zn-z","graphic":"_n-z","contact":"ao-z"};